import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { getMergedClassNames, getUniqueKey } from '../../../../utils/HTMLutils'
import './TextEditorHeaderInput.scss'
const rootClassName = 'text-editor-header-input'

export default function TextEditorHeaderInput(props) {
  const [inputLabelId] = useState(getUniqueKey())

  const getInputProps = () => {
    return {
      onFocus: (evt) => {
        document.getElementById(inputLabelId).classList.add('top')
        if (typeof props.onFocus === 'function') props.onFocus(evt)
      },
      onBlur: (evt) => {
        if (!props.value) {
          document.getElementById(inputLabelId).classList.remove('top')
        }
      },
      onChange: (evt) => {
        props.onChange(evt)
        evt.stopPropagation()
      },
      className: getMergedClassNames([
        `${rootClassName}-input`,
        props.className || ''
      ]),
      value: props.value,
      onKeyUp: (evt) => {
        if (evt.key === 'Enter' && typeof props.onEnter === 'function') {
          props.onEnter()
        }
      }
    }
  }

  return (
    <div className={rootClassName}>
      <div
        id={inputLabelId}
        className={getMergedClassNames([
          `${rootClassName}-label`,
          props.value ? 'top' : ''
        ])}
      >
        {props.label}
      </div>
      <input {...getInputProps()} />
    </div>
  )
}

TextEditorHeaderInput.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onEnter: PropTypes.func
}

TextEditorHeaderInput.defaultProps = {
  onChange: () => {}
}
